
































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import router from '@/router';
import { ObjectFactory } from '../config/objectFactory';
import { MedTransGoConstants } from '../util/constants';
import DataTable from '../components/DataTable.vue';
import { CommonUtils } from '../util/commonUtils';
import { DateUtils } from '../util/dateUtils';
import { MathUtils } from '../util/mathUtils';
import { HealthcareProvider, Invoice, MonthlyInvoice, Organization, Particular, Patient, SurchargeItem } from '../types/entity';
import { Condition } from '../types/queryRequest';
import Menu from '../components/Menu.vue';
import { ResourceUtils } from '@/util/resourceUtils';
import { AdvanceFilterRequest, ApiRequest, GenerateMasterInvoiceRequest, QueryRecordsRequest } from '@/types/request';
import { ModelSelect } from 'vue-search-select';
import ViewReceiptModal from './modal/ViewReceiptModal.vue';
import { ToastEvent } from '@/types/event';
import { EventBus } from '@/main';
// tslint:disable-next-line: no-var-requires
const InvoicesTable = require('../datatable/InvoicesTable.json');
// tslint:disable-next-line: no-var-requires
const monthlyInvoice = require('../datatable/MonthlyInvoice.json');
import PayInvoicesModal from './modal/PayInvoicesModal.vue';
// tslint:disable-next-line: no-var-requires
const BillingStatementTable = require('../datatable/BillingStatementTable.json');
import { OrgLocation } from '@/types/entity';
import { MemberProfile } from '@/types/response';
// tslint:disable-next-line: no-var-requires
const masterInvoiceTable = require('../datatable/MasterInvoiceDataTable.json');
@Component({
    watch: {
        $route(to, from) {
            const request = this as Invoices;
            request.searchPatientInvoice('', 0);
        },
    },
    methods: {
        goBack() {
            router.push({ name: MedTransGoConstants.VIEW_REQUESTS_PANEL_NAME });
        },

    },
    data() {
        return {
            selectedDateRange: '',
            dateRangeOptions: [
                { value: '', text: 'Select Date Period', disabled: true },
                { value: 'Last 30 Days', text: 'Last 30 Days' },
                { value: 'Last 60 Days', text: 'Last 60 Days' },
                { value: 'Last 90 Days', text: 'Last 90 Days' },
                { value: 'Year to Date', text: 'Year to Date' },
                { value: 'Custom Date Range', text: 'Custom Date Range' },
            ],
            header: 'Invoices',
            options: [
                {
                    url: 'invoices?invoiceType=Patient',
                    activeConditions: {
                        invoiceType: 'Patient',
                    },
                    label: 'Line Item Invoices',
                },
                {
                    url: 'invoices?invoiceType=BillingStatement',
                    activeConditions: {
                        invoiceType: 'BillingStatement',
                    },
                    label: 'Billing Statements',
                },
                {
                    url: 'invoices?invoiceType=Master',
                    activeConditions: {
                        invoiceType: 'Master',
                    },
                    label: 'Master Invoice',
                },
            ],
            showChargeInvoiceModal: false,
            serviceOptions: [
                {
                    value: 'All',
                    text: 'All',
                    id: null,
                },
                {
                    value: 'transportRequest',
                    text: 'Transportation',
                    id: 'Transportation',
                },
                {
                    value: 'interpreterRequest',
                    text: 'Interpretation',
                    id: 'Interpretation',
                },
                {
                    value: 'telemedicineRequest',
                    text: 'Telemedicine',
                    id: 'Telemedicine',
                },
                {
                    value: 'deliveryRequest',
                    text: 'Delivery',
                    id: 'Delivery',
                },
                {
                    value: 'homeHealthCareRequest',
                    text: 'Home Health Care',
                    id: 'HomeHealthCare',
                },
            ],
            statusOptions: [
                {
                    value: 'All',
                    text: 'All',
                    id: null,
                },
                {
                    value: 'Pending',
                    text: 'Unpaid',
                    id: 'Pending',
                },
                {
                    value: 'Completed',
                    text: 'Paid',
                    id: 'Completed',
                },
            ],
            paymentStatus: '',
            paymentStatusOptions: [
                {
                    value: 'All',
                    text: 'All',
                    id: null,
                },
                {
                    value: 'Unpaid',
                    text: 'Unpaid',
                    id: 'Pending',
                },
                {
                    value: 'Paid',
                    text: 'Paid',
                    id: 'Processed',
                },
            ],
            patientOptions: [],
            providersOptions: [],
            billingLocationOptions: [],
            selectedFacilities: [],
            currentPage: 0,
            facilitySelectKey: 0,
            selectedMonth: null,
            billingContactOptions: [],
            selectedBillingContacts: [],
            selectedBillingPeriod: null,
            caseNumberOptions: [],
        };
    },
    components: {
        DataTable,
        Menu,
        ViewReceiptModal,
        ModelSelect,
        PayInvoicesModal,
    },
})
export default class Invoices extends Vue {

    private monthlyInvoiceDataSource = monthlyInvoice;
    private invoicesDataSource = InvoicesTable;
    private type: any = 'I';
    private monthlyInvoiceStart = 0;
    private organizationId = '';
    private fileName = '';
    private showMonthlyInvoice = false;
    private chargeInvoiceDetails: any = {
        invoiceId: '',
        amount: 0,
        payInvoice: false,
        particulars: [],
        isMasterInvoice: false,
    };
    private patients: Patient[] = [];
    private patientName: any[] = [];
    private healthcareProviders: HealthcareProvider[] = [];
    private startDate: any | undefined = '';
    private endDate: any | undefined = '';
    private service: any[] = [];
    private advanceFilterRequest: AdvanceFilterRequest = {};
    private patientInvoiceStart = 0;
    private viewRecieptModal = false;
    private selectedInvoiceAmountIn$ = '';
    private selectedInvoiceCount = 0;
    private selectedInvoiceAmounntInCents = 0;
    private showPayInvoiceModal = false;
    private selectedInvoices: Invoice[] = [];
    private billingStatementDataSource = BillingStatementTable;
    private monthlyInvoiceId: string | undefined = '';
    private invoicesResult: any[] = [];
    private locations: OrgLocation[] = [];
    private billingLocationName: any[] = [];
    private idCounter = 0;
    private selectedAttributess: any[] = [];
    private showPayInvoicesButton = false;
    private managerBllingLocations: OrgLocation[] = [];
    private memberProfile: MemberProfile = {} as any;
    private completedMonths: any[] = [];
    private billingContacts: any[] = [];
    private organization: Organization = {} as any;
    private msaterDataSource = masterInvoiceTable;
    private masterInvoiceStart = 0;
    private selectedBillingStatementAttributes: any[] = [];

    public async mounted() {
        this.memberProfile = await ObjectFactory.getCacheService().getMemberInfo();
        if (this.memberProfile.memberType === 'ORG_CUSTOMER') {
            this.$router.push({ name: MedTransGoConstants.VIEW_REQUESTS_PANEL_NAME });
        }
        if (this.memberProfile.memberType === 'ORG_MANAGER') {
            this.$data.options.pop();
            if (this.memberProfile.managedLocations && this.memberProfile.managedLocations.length > 0) {
                this.memberProfile.managedLocations.forEach((location) => {
                    this.managerBllingLocations.push(location);
                });
            }
        }
        if (this.memberProfile && this.memberProfile.organization) {
            this.organizationId = this.memberProfile.organization.id;
            const resp = await ObjectFactory.getMemberService()
                .getOrganizationById(this.organizationId, this.$store.state.serverUrl);
            if (resp.data) {
                this.organization = resp.data;
                const hasReimbursement = this.organization.reimbursementRateDetails &&
                    this.organization.reimbursementRateDetails.length > 0;
                this.billingContacts = resp.data.billingContacts ? resp.data.billingContacts : [];
                if (resp.data.invoiceMode === 'Immediate' || hasReimbursement || this.memberProfile.memberType === 'ORG_LIEN_CUSTOMER') {
                    this.$data.options = this.$data.options.filter((option: any) =>
                    option.activeConditions.invoiceType === 'Patient');
                }
            }
        }
        this.getOrganizationLocations();
        this.getPatients();
        this.getHealthcareProviders();
        this.searchPatientInvoice('', 0);
        this.getMonthlyInvoices('', 0);
        this.completedMonths = DateUtils.getCompletedMonthsFrom(2025);
        this.getBillingContacts();
        this.getMasterInvoiceList('', 0);
    }

    private viewInvoice(invoice: Invoice) {
        if (invoice.pdfResourceId) {
            this.fileName = invoice.pdfResourceId;
        }
        this.viewRecieptModal = true;
    }
    private viewOriginalInvoice(invoice: Invoice) {
        this.$router.push({ path: `/invoices/${invoice.id}?orignal=true` });
    }

    private async viewReceipt(invoice: Invoice) {
        if (invoice.paymentResponse) {
            window.open(invoice.paymentResponse.receiptUrl, 'Payment Receipt', 'width=600,height=800');
        }
    }

    private viewOrderForm(invoice: Invoice) {
        if (invoice.requestId) {
            this.$router.push({
                path: MedTransGoConstants.URL_VIEW_ORDER.replace(':id',
                    invoice.requestId), append: true,
            });
        }
    }

    private async downloadInvoice(invoice: any) {
        const pdfBuffer = await ObjectFactory.getInvoiceService()
            .getInvoiceReceipt(this.$store.state.serverUrl, invoice.id) as any;
        const file = new Blob([pdfBuffer], { type: 'application/pdf' });
        ResourceUtils.downloadFileIntoDevice(file, `${invoice.invoiceId}.pdf`);
    }

    private async filterRequests(filter: any) {
        this.searchPatientInvoice('', 0);
    }

    private async searchPatientInvoice(searchString?: string, start?: number) {
        this.selectedInvoiceCount = 0;
        this.selectedInvoiceAmountIn$ = '';
        if (start === undefined) {
            start = this.patientInvoiceStart;
        } else {
            this.patientInvoiceStart = start;
        }
        this.$data.currentPage = start;
        this.type = this.$route.query.type ? this.$route.query.type : 'I';
        const invoiceType = this.$route.query.invoiceType;
        const conditions: Condition[] = [];
        const serviceFilters: any[] = this.selectedAttributess.filter((attr) => attr.type === 'Service');
        const patientFilters: any[] = this.selectedAttributess.filter((attr) => attr.type === 'Patient');
        const locationFilters: any[] = this.selectedAttributess.filter((attr) => attr.type === 'BillingLocation');
        const statusFilters: any[] = this.selectedAttributess.filter((attr) => attr.type === 'Status');
        const providerFilters: any[] = this.selectedAttributess.filter((attr) => attr.type === 'Facility');
        const caseNumberFilters: any[] = this.selectedAttributess.filter((attr: any) => attr.type === 'CaseNumber');
        if (serviceFilters && serviceFilters.length > 0) {
            const condition: Condition = {
                op: 'or',
                conditions: [],
            };
            const services = serviceFilters.map((service: any) => service.text);
            services.forEach((service: any) => {
                if (condition.conditions) {
                    condition.conditions.push({
                        op: 'ne',
                        fieldName: `requests.${service}`,
                        value: null,
                    });
                }
            });
            conditions.push(condition);
        }
        if (patientFilters && patientFilters.length > 0) {
            const condition: Condition = {
                op: 'or',
                conditions: [],
            };
            const patientNames = patientFilters.map((service: any) => service.text);
            patientNames.forEach((name) => {
                if (condition.conditions) {
                    condition.conditions.push({
                        op: 'eq',
                        fieldName: 'patientName',
                        value: name,
                    });
                }
            });
            conditions.push(condition);
        }
        if (caseNumberFilters.length > 0) {
            const condition: Condition = {
                op: 'or',
                conditions: [],
            };
            const caseNumbers = caseNumberFilters.map((service: any) => service.text);
            caseNumbers.forEach((caseNumber) => {
                if (condition.conditions) {
                    condition.conditions.push({
                        op: 'eq',
                        fieldName: 'caseNumber',
                        value: caseNumber,
                    });
                }
            });
            conditions.push(condition);
        }
        if (locationFilters && locationFilters.length > 0) {
            const condition: Condition = {
                op: 'or',
                conditions: [],
            };
            const locations = locationFilters.map((service: any) => service.value);
            locations.forEach((location) => {
                if (condition.conditions) {
                    condition.conditions.push({
                        op: 'eq',
                        fieldName: 'billingLocation.id',
                        value: location.id,
                    });
                }
            });
            conditions.push(condition);
        } else if (this.memberProfile.memberType === 'ORG_MANAGER' && this.managerBllingLocations.length > 0) {
            const condition: Condition = {
                op: 'or',
                conditions: [],
            };
            this.managerBllingLocations.forEach((location) => {
                if (condition.conditions) {
                    condition.conditions.push({
                        op: 'eq',
                        fieldName: 'billingLocation.id',
                        value: location.id,
                    });
                }
            });
            conditions.push(condition);
        }
        if (providerFilters && providerFilters.length > 0) {
            const condition: Condition = {
                op: 'or',
                conditions: [],
            };
            const providers = providerFilters.map((service: any) => service.text);
            providers.forEach((providerName) => {
                if (condition.conditions) {
                    condition.conditions.push({
                        op: 'eq',
                        fieldName: 'requests.appointment.facility.name',
                        value: providerName,
                    });
                }
            });
            conditions.push(condition);
        }
        const approvedOnFilterDate = new Date(Date.UTC(2025, 3, 1, 0, 0, 0)).getTime();
        conditions.push({
            op: 'and',
            conditions: [
                {
                    fieldName: 'approvedOn',
                    op: 'ne',
                    value: null,
                },
                {
                    fieldName: 'approvedOn',
                    op: 'gte',
                    value: approvedOnFilterDate,
                },
            ],
        });
        if (this.startDate && this.startDate !== '' && this.endDate && this.endDate !== '') {
            const startDate = DateUtils.convertToUTCInMillis(this.startDate);
            const endDate = DateUtils.convertToUTCInMillis(this.endDate);
            conditions.push({
                fieldName: 'createdOn',
                op: 'between',
                value: [startDate, endDate],
            });
        }
        let response: any;
        if (invoiceType === 'Patient') {
            if (statusFilters && statusFilters.length > 0) {
                const condition: Condition = {
                    op: 'or',
                    conditions: [],
                };
                const status = statusFilters.map((service: any) => service.text);
                status.forEach((s) => {
                    if (condition.conditions) {
                        condition.conditions.push({
                            op: 'eq',
                            fieldName: 'status',
                            value: s === 'Completed' ? 'Completed' : 'Approved',
                        });
                    }
                });
                conditions.push(condition);
            } else {
                conditions.push({
                    op: 'in',
                    fieldName: 'status',
                    value: ['Completed', 'Approved'],
                });
            }
            response = await ObjectFactory.getInvoiceService()
                .getInvoiceList(this.$store.state.serverUrl, {
                    conditions,
                    advanceFilterRequest: this.advanceFilterRequest,
                    start: start ? start : 0,
                    limit: MedTransGoConstants.PAGINATION_LIMIT,
                }, this.type);
        } else if (invoiceType === 'BillingStatement') {
           this.getMonthlyInvoices('', 0);
        }
        if (response && response.success && response.data) {
            if (invoiceType === 'Patient') {
                response.data.forEach((element: any) => {
                    element.totalAmount = 0;
                    element.particulars.forEach((iElement: any) => {
                        element.totalAmount += iElement.amount;
                    });
                    element.status = element.status === 'Completed' ? 'Paid' : 'Unpaid';
                    element.totalAmount = MathUtils.formatCurrency(element.totalAmount);
                    element.createdOn = DateUtils.formatDate(element.createdOn);
                    element.invoiceMode = this.organization.invoiceMode;
                    element.isLienCustomer =  this.memberProfile.memberType === 'ORG_LIEN_CUSTOMER';
                });
                this.invoicesDataSource.data = response.data;
                this.invoicesResult = response.data;
                if (response.totalCount) {
                    this.invoicesDataSource.totalCount = response.totalCount;
                }
            } else if (invoiceType === 'Monthly') {
                response.data.forEach((invoice: MonthlyInvoice) => {
                    invoice.createdOn = DateUtils.formatDate(invoice.createdOn, DateUtils.FORMAT_DATETIME_AM_PM) as any;
                    invoice.dueDate = DateUtils.formatDate(invoice.dueDate, DateUtils.FORMATE_DATE);
                    invoice.amount = `$${(parseFloat(invoice.amount) / 100).toFixed(2)}`;
                });
                this.monthlyInvoiceDataSource.data = response.data;
                this.invoicesResult = response.data;
                if (response.totalCount) {
                    this.monthlyInvoiceDataSource.totalCount = response.totalCount;
                }
            }
        } else {
            this.invoicesDataSource.data = [];
            CommonUtils.showError(response);
        }
    }

    private async viewMonthlyInvoice(invoiceDetails: any) {
        this.fileName = invoiceDetails.pdfResourceUrl;
        this.showMonthlyInvoice = true;
    }

    private viewPaymentReciept(invoiceDetails: MonthlyInvoice) {
        window.open(invoiceDetails.paymentInfo.receiptUrl, '_blank');
    }

    private viewInvoicePaymentReciept(invoice: any) {
        if (invoice.paymentResponse) {
            window.open(invoice.paymentResponse.receiptUrl, '_blank');
        }
    }

    private viewChargeInvoiceModal(invoice: any, isMasterInvoice?: boolean) {
        const pdfResourceId = invoice.pdfResourceId || invoice.pdfResourceUrl;
        if (pdfResourceId && invoice.id) {
            this.fileName = pdfResourceId;
            if (isMasterInvoice) {
                this.chargeInvoiceDetails = {
                    amount: invoice.amount,
                    invoiceId: invoice.id,
                    payInvoice: true,
                    isMasterInvoice: true,
                    particulars: null as any,
                    billingStatementIds: invoice.billingStatementIds,
                    organizationId: this.organizationId,
                    billingLocationIds: invoice.billingLocationIds,
                };
            } else {
                const invoiceDetails = this.invoicesResult.find((e) => e.id === invoice.id);
                this.chargeInvoiceDetails = {
                    amount: invoice.details.totalAmount,
                    invoiceId: invoice.id,
                    payInvoice: true,
                    particulars: invoiceDetails ? invoiceDetails.particulars : [] as any,
                    isMasterInvoice: false,
                    billingLocation: invoice.billingLocation ? invoice.billingLocation : '',
                };
            }
            this.$data.showChargeInvoiceModal = true;
        }
    }

    private async getHealthcareProviders() {
        const response = await ObjectFactory.getProviderService()
            .getHealthcareProviders(this.$store.state.serverUrl, '', 0, MedTransGoConstants.DB_QUERY_MAX_RESULT);
        this.healthcareProviders = response.data as any;
        this.$data.providersOptions = [];
        this.healthcareProviders.forEach((healthcareProvider) => {
            if (healthcareProvider.status === 'ACTIVE') {
                const providersOption = {
                    value: healthcareProvider.fullname,
                    text: healthcareProvider.fullname,
                    id: this.idCounter++,
                };
                this.$data.providersOptions.push(providersOption);
            }
        });
        const allOption = {
            value: 'All',
            text: 'All',
        };
        this.$data.providersOptions.unshift(allOption);
    }

    private async getMonthlyInvoices(searchString?: string, start?: number) {
        this.selectedBillingStatementAttributes.filter((attr) => attr && attr.text);
        const locationFilters: any[] = this.selectedBillingStatementAttributes.filter((attr: any) => attr.type === 'BillingLocation');
        const billingPeriodFilters: any[] = this.selectedBillingStatementAttributes.filter((attr: any) =>
            attr.type === 'BillingPeriod');
        const organizationId = this.organizationId;
        if (typeof start !== 'undefined') {
            this.monthlyInvoiceStart = start;
        } else if (this.monthlyInvoiceStart > 0) {
            start = this.monthlyInvoiceStart;
        }
        this.$data.currentPage = start;
        const conditions: Condition[] = [];
        if (this.startDate && this.startDate !== '' && this.endDate && this.endDate !== '') {
            conditions.push({
                op: 'gte',
                fieldName: 'createdOn',
                value: DateUtils.convertToUTCInMillis(this.startDate),
            });
            conditions.push({
                op: 'lte',
                fieldName: 'createdOn',
                value: DateUtils.convertToUTCInMillis(this.endDate),
            });
        }
        // if (this.$data.paymentStatus && this.$data.paymentStatus !== '') {
        //     if (this.$data.paymentStatus === 'Processed') {
        //         const condition: Condition = {
        //             op: 'eq',
        //             fieldName: 'status',
        //             value: this.$data.paymentStatus,
        //         };
        //         conditions.push(condition);
        //     } else if (this.$data.paymentStatus === 'Pending') {
        //         const condition: Condition = {
        //             op: 'in',
        //             fieldName: 'status',
        //             value: ['Pending', 'Failed'],
        //         };
        //         conditions.push(condition);
        //     }
        // } else {
        //     conditions.push({
        //         op: 'in',
        //         fieldName: 'status',
        //         value: ['Processed', 'Pending', 'Failed'],
        //     });
        // }
        if (locationFilters && locationFilters.length > 0) {
            const condition: Condition = {
                op: 'or',
                conditions: [],
            };
            const locations = locationFilters.map((service: any) => service.value);
            locations.forEach((location) => {
                if (condition.conditions) {
                    condition.conditions.push({
                        op: 'eq',
                        fieldName: 'billingLocation.id',
                        value: location.id,
                    });
                }
            });
            conditions.push(condition);
        }
        if (billingPeriodFilters && billingPeriodFilters.length > 0) {
            const condition: Condition = {
                op: 'or',
                conditions: [],
            };
            const billingPeriod = billingPeriodFilters.map((service: any) => service.text);
            billingPeriod.forEach((selectedMonth) => {
                if (condition.conditions) {
                    condition.conditions.push({
                        op: 'eq',
                        fieldName: 'month',
                        value: selectedMonth,
                    });
                }
            });
            conditions.push(condition);
        }
        const iHttpService = ObjectFactory.getHttpService();
        const queryRecordsRequest: QueryRecordsRequest = {
            limit: MedTransGoConstants.PAGINATION_LIMIT,
            start: start ? start : 0,
            order: {
                createdOn: -1,
            },
            conditions,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_INVOICE}/${organizationId}/getmonthlyInvoiceList`,
            data: queryRecordsRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<MonthlyInvoice[]>(apiRequest);
        if (response.success && response.data) {
            response.data.forEach((invoice: MonthlyInvoice) => {
                if (invoice.month) {
                    invoice.dateRange = DateUtils.getDateRangeFromMonth(invoice.month);
                } else if (invoice.createdOn) {
                    const endTime = invoice.createdOn - (1 * 24 * 60 * 60 * 1000);
                    const startTime = endTime - (15 * 24 * 60 * 60 * 1000);
                    invoice.dateRange = `${DateUtils.formatDate(startTime, DateUtils.FORMATE_DATE)} - ${DateUtils.formatDate(endTime, DateUtils.FORMATE_DATE)}`;
                }
                const billingContactDetails = this.billingContacts.filter((contact) => {
                if (invoice.billingLocation && invoice.billingLocation.id) {
                    return contact.billingLocationIds.includes(invoice.billingLocation.id);
                }
                });
                invoice.billingContacts = billingContactDetails.map((contact) => contact.name).join(', ');
                invoice.dueDate = DateUtils.formatDate(invoice.dueDate, DateUtils.FORMATE_DATE);
                invoice.amount = `$${(parseFloat(invoice.amount) / 100).toFixed(2)}`;
                if (invoice.status === 'Pending' || invoice.status === 'Failed') {
                    invoice.status = 'Unpaid';
                } else {
                    invoice.status = 'Paid';
                }
            });
            this.billingStatementDataSource.data = response.data;
            if (response.totalCount) {
                this.billingStatementDataSource.totalCount = response.totalCount;
            }
        }
    }

    private async getPatients() {
        const response = await ObjectFactory.getPatientService()
            .getPatientList(this.$store.state.serverUrl, '', 0, MedTransGoConstants.DB_QUERY_MAX_RESULT);
        this.patients = response.data as any;
        this.$data.patientOptions = [];
        this.patients.forEach((patient) => {
            const patientOption = {
                value: patient.fullName,
                text: patient.fullName,
                id: this.idCounter++,
            };
            this.$data.patientOptions.push(patientOption);
            if (patient.caseNumber) {
            this.$data.caseNumberOptions.push({
                value: patient.caseNumber,
                text: patient.caseNumber,
                id: this.idCounter++,
            });
        }
        });
        const allOption = {
            value: 'All',
            text: 'All',
            id: null,
        };
        this.$data.patientOptions.unshift(allOption);
        this.$data.caseNumberOptions.unshift({
            value: 'All',
            text: 'All',
            patientId: null,
        });
    }

    private async getConsolidatedInvoice(responseType: 'pdf' | 'excel') {
        const conditions: Condition[] = [];
        const serviceFilters: any[] = this.selectedAttributess.filter((attr: any) => attr.type === 'Service');
        const patientFilters: any[] = this.selectedAttributess.filter((attr: any) => attr.type === 'Patient');
        const locationFilters: any[] = this.selectedAttributess.filter((attr: any) => attr.type === 'BillingLocation');
        const statusFilters: any[] = this.selectedAttributess.filter((attr: any) => attr.type === 'Status');
        const providerFilters: any[] = this.selectedAttributess.filter((attr: any) => attr.type === 'Facility');
        const caseNumberFilters: any[] = this.selectedAttributess.filter((attr: any) => attr.type === 'CaseNumber');
        if (serviceFilters && serviceFilters.length > 0) {
            const condition: Condition = {
                op: 'or',
                conditions: [],
            };
            const services = serviceFilters.map((service: any) => service.text);
            services.forEach((service: any) => {
                if (condition.conditions) {
                    condition.conditions.push({
                        op: 'ne',
                        fieldName: `requests.${service}`,
                        value: null,
                    });
                }
            });
            conditions.push(condition);
        }
        if (patientFilters && patientFilters.length > 0) {
            const condition: Condition = {
                op: 'or',
                conditions: [],
            };
            const patientNames = patientFilters.map((service: any) => service.text);
            patientNames.forEach((name) => {
                if (condition.conditions) {
                    condition.conditions.push({
                        op: 'eq',
                        fieldName: 'patientName',
                        value: name,
                    });
                }
            });
            conditions.push(condition);
        }
        if (caseNumberFilters.length > 0) {
            const condition: Condition = {
                op: 'or',
                conditions: [],
            };
            const caseNumbers = caseNumberFilters.map((service: any) => service.text);
            caseNumbers.forEach((caseNumber) => {
                if (condition.conditions) {
                    condition.conditions.push({
                        op: 'eq',
                        fieldName: 'caseNumber',
                        value: caseNumber,
                    });
                }
            });
            conditions.push(condition);
        }
        if (locationFilters && locationFilters.length > 0) {
            const condition: Condition = {
                op: 'or',
                conditions: [],
            };
            const locations = locationFilters.map((service: any) => service.value);
            locations.forEach((location) => {
                if (condition.conditions) {
                    condition.conditions.push({
                        op: 'eq',
                        fieldName: 'billingLocation.id',
                        value: location.id,
                    });
                }
            });
            conditions.push(condition);
        } else if (this.memberProfile.memberType === 'ORG_MANAGER' && this.managerBllingLocations.length > 0) {
            const condition: Condition = {
                op: 'or',
                conditions: [],
            };
            this.managerBllingLocations.forEach((location) => {
                if (condition.conditions) {
                    condition.conditions.push({
                        op: 'eq',
                        fieldName: 'billingLocation.id',
                        value: location.id,
                    });
                }
            });
            conditions.push(condition);
        }
        if (providerFilters && providerFilters.length > 0) {
            const condition: Condition = {
                op: 'or',
                conditions: [],
            };
            const providers = providerFilters.map((service: any) => service.text);
            providers.forEach((providerName) => {
                if (condition.conditions) {
                    condition.conditions.push({
                        op: 'eq',
                        fieldName: 'requests.appointment.facility.name',
                        value: providerName,
                    });
                }
            });
            conditions.push(condition);
        }
        if (statusFilters && statusFilters.length > 0) {
            const condition: Condition = {
                op: 'or',
                conditions: [],
            };
            const status = statusFilters.map((service: any) => service.text);
            status.forEach((s) => {
                if (condition.conditions) {
                    condition.conditions.push({
                        op: 'eq',
                        fieldName: 'status',
                        value: s === 'Completed' ? 'Completed' : 'Approved',
                    });
                }
            });
            conditions.push(condition);
        } else {
            conditions.push({
                op: 'in',
                fieldName: 'status',
                value: ['Completed', 'Approved'],
            });
        }
        if (this.startDate && this.startDate !== '' && this.endDate && this.endDate !== '') {
            const startDate = DateUtils.convertToUTCInMillis(this.startDate);
            const endDate = DateUtils.convertToUTCInMillis(this.endDate);
            conditions.push({
                fieldName: 'createdOn',
                op: 'between',
                value: [startDate, endDate],
            });
        }
        conditions.push({
            op: 'ne',
            value: 'Billed Amount',
            fieldName: 'invoiceName',
        });
        const queryRecordRequest: QueryRecordsRequest = {
            conditions,
            op: 'or',
            responseType,
            limit: 1000,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_INVOICES}/consolidatedInvoice`,
            data: queryRecordRequest,
            responseType: 'arraybuffer',
            loaderEvent: {
                show: true,
            },

        };
        const iHttpService = ObjectFactory.getHttpService();
        const response = await iHttpService.post<any>(apiRequest);
        if (responseType === 'pdf') {
            const file = new Blob([response as any], { type: 'application/pdf' });
            ResourceUtils.downloadFileIntoDevice(file, `ServiceReport_${DateUtils.formatDate(Date.now(), 'MMDDYYYYHHMM')}.pdf`);
        } else {
            const file = new Blob([response as any],
                { type: 'vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const fileName = `Invoices_${DateUtils.formatDate(Date.now(), 'MMDDYYYYHHMM')}.xlsx`;
            ResourceUtils.downloadFileIntoDevice(file, fileName);
            return response;
        }
    }

    private emitSelectedInvoices(itemData: any[]) {
        this.selectedInvoices = itemData;
        this.selectedInvoiceAmounntInCents = 0;
        this.showPayInvoicesButton = false;
        itemData.forEach((invoice: any) => {
            let amountincents = MathUtils.calculateTotal(invoice.particulars);
            const invoiceDetails = this.invoicesResult.find((e) => e.id === invoice.id);
            if (invoiceDetails && invoiceDetails.status === 'Unpaid') {
                this.showPayInvoicesButton = true;
                const lienServiceSurcharge = this.findSurchargeByName(invoiceDetails.particulars, 'Service Fee');
                if (lienServiceSurcharge) {
                    amountincents -= lienServiceSurcharge.amount;
                }
                if (amountincents && amountincents > 0) {
                    this.selectedInvoiceAmounntInCents += amountincents;
                }
            }
        });
        this.selectedInvoiceCount = itemData.length;
    }

    private async showPayInvoicesModal() {
        this.showPayInvoiceModal = true;
    }

    get selectedInvoicesAmountInUSD() {
        return MathUtils.formatCurrencyWithoutRound(this.selectedInvoiceAmounntInCents);
    }

    private async clearFilters() {
        this.$data.selectedMonth = null;
        this.getMonthlyInvoices('', 0);
        this.$nextTick(() => {
            this.selectedBillingStatementAttributes = [];
        });
    }

    private async downloadSelectedInvoices() {
        for (const invoice of this.selectedInvoices) {
            this.downloadInvoice(invoice);
        }
    }

    private convertDollarToCents(dollarString: string): number {
        const normalized = dollarString.replace(/\$|,/g, '');
        const cents = Math.round(parseFloat(normalized) * 100);
        return cents;
    }

    private async getInvoicesInMonthlyInvoice(invoiceDetails: MonthlyInvoice) {
        this.selectedInvoices = [];
        const fileName = invoiceDetails.pdfResourceUrl;
        this.monthlyInvoiceId = invoiceDetails.id;
        if (invoiceDetails.invoices && invoiceDetails.invoices.length) {
            const requestIds = invoiceDetails.invoices.map((invoice) => invoice.requestId);
            for (const requestId of requestIds) {
                const iHttpService = ObjectFactory.getHttpService();
                const apiRequest: ApiRequest = {
                    baseURL: this.$store.state.serverUrl,
                    url: `${MedTransGoConstants.HTTP_URL_REQUEST}/${requestId}/invoices`,
                    loaderEvent: {
                        show: true,
                    },
                };
                const invoices = await iHttpService.get<Invoice[]>(apiRequest);
                if (invoices.success && invoices.data) {
                    for (const invoice of invoices.data) {
                        if (invoice && invoice.status !== 'Completed') {
                            this.selectedInvoices.push(invoice);
                        }
                    }
                }
            }
            this.showPayInvoicesModal();
        } else {
            const response = await ObjectFactory.getHttpService().get<any>({
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_RESOURCE}/extractPDF/${fileName}`,
                loaderEvent: {
                    show: true,
                },
            });
            if (response.success && response.data) {
                for (const requestId of response.data.requestIds) {
                    const iHttpService = ObjectFactory.getHttpService();
                    const apiRequest: ApiRequest = {
                        baseURL: this.$store.state.serverUrl,
                        url: `${MedTransGoConstants.HTTP_URL_REQUEST}/${requestId}/invoices`,
                        loaderEvent: {
                            show: true,
                        },
                    };
                    const invoices = await iHttpService.get<Invoice[]>(apiRequest);
                    if (invoices.success && invoices.data) {
                        for (const invoice of invoices.data) {
                            if (invoice && invoice.status !== 'Completed') {
                                this.selectedInvoices.push(invoice);
                            }
                        }
                    }
                }
                this.showPayInvoicesModal();
            } else {
                CommonUtils.showError(response);
            }
        }
    }

    private async searchIncoices() {
        const start = this.$data.currentPage;
        if (this.$route.query.invoiceType === 'BillingStatement') {
            this.getMonthlyInvoices('', start);
        } else {
            this.searchPatientInvoice('', start);
        }
    }

    private findSurchargeByName(particulars: Particular[], surchargeName: string): SurchargeItem | undefined {
        for (const particular of particulars) {
            if (particular.breakup && particular.breakup.surcharges) {
                const surcharge = particular.breakup.surcharges.find(
                    (item) => item.description === surchargeName,
                );
                if (surcharge) {
                    return surcharge;
                }
            }
        }
        return undefined;
    }

    private updateDateRange() {
        const today = new Date();
        const year = today.getFullYear();
        let startDate: string | null = null;
        let endDate: string | null = null;

        switch (this.$data.selectedDateRange) {
            case 'Last 30 Days':
                startDate = new Date(today.setDate(today.getDate() - 30)).toISOString().split('T')[0];
                endDate = new Date().toISOString().split('T')[0];
                break;
            case 'Last 60 Days':
                startDate = new Date(today.setDate(today.getDate() - 60)).toISOString().split('T')[0];
                endDate = new Date().toISOString().split('T')[0];
                break;
            case 'Last 90 Days':
                startDate = new Date(today.setDate(today.getDate() - 90)).toISOString().split('T')[0];
                endDate = new Date().toISOString().split('T')[0];
                break;
            case '2025 Year to Date':
                startDate = new Date(year, 0, 1).toISOString().split('T')[0];
                endDate = new Date().toISOString().split('T')[0];
                break;
            case '2024':
            case '2023':
            case '2022':
            case '2021':
                startDate = new Date(Number(this.$data.selectedDateRange), 0, 1).toISOString().split('T')[0];
                endDate = new Date(Number(this.$data.selectedDateRange), 11, 31).toISOString().split('T')[0];
                break;
            case 'Custom Date Range':
                startDate = '';
                endDate = '';
                break;
        }

        this.startDate = startDate;
        this.endDate = endDate;

        this.addDatePeriod(this.$data.selectedDateRange);
    }

    private async getOrganizationLocations() {
        this.$data.billingLocationOptions = [];
        const response = await ObjectFactory.getOrganizationService().getLocations(this.$store.state.serverUrl);
        if (response.success && response.data) {
            response.data.sort((a, b) => (a.locationName || '').localeCompare(b.locationName || ''));
            this.locations = response.data;
            response.data.forEach((location) => {
                let permissionDenied = false;
                if (location.locationName && this.memberProfile.memberType === 'ORG_MANAGER'
                    && this.managerBllingLocations.length > 0
                    && !this.managerBllingLocations.some((managedLoc: any) => managedLoc.id === location.id)) {
                    permissionDenied = true;
                }
                if (!permissionDenied) {
                    const option = {
                        value: location,
                        text: location.locationName,
                        id: this.idCounter++,
                    };
                    this.$data.billingLocationOptions.push(option);
                }
            });
            const allOption = {
                value: 'All',
                text: 'All',
                id: null,
            };
            this.$data.billingLocationOptions.unshift(allOption);
        }
    }

    private addService(serviceName: any) {
        const exists = this.selectedAttributess.some((attr: any) => attr.text === serviceName);
        if (!exists && serviceName !== 'All') {
            const providerOption = {
                text: serviceName,
                id: this.idCounter ++,
                type: 'Service',
            };
            this.selectedAttributess.push(providerOption);
            this.service.push(providerOption);
        }
    }
    private addFacility(facilityName: any) {
        const exists = this.selectedAttributess.some((attr: any) => attr.text === facilityName);
        if (!exists && facilityName !== 'All') {
            const providerOption = {
                text: facilityName,
                id: this.idCounter ++,
                type: 'Facility',
            };
            this.selectedAttributess.push(providerOption);
        }
    }
    private addPatient(patientName: any) {
        const exists = this.selectedAttributess.some((attr: any) => attr.text === patientName);
        if (!exists && patientName !== 'All') {
            const patientOption = {
                text: patientName,
                id: this.idCounter ++,
                type: 'Patient',
            };
            this.selectedAttributess.push(patientOption);
        }
    }
    private addBillingLocation(billingLocation: any) {
        const selectedAttributes = this.$route.query.invoiceType === 'BillingStatement'
        ? this.selectedBillingStatementAttributes : this.selectedAttributess;
        const exists = selectedAttributes.some((attr: any) => attr.text
            === billingLocation.locationName && attr.type === 'BillingLocation');
        if (!exists && billingLocation !== 'All') {
            const billingCodeOption = {
                text: billingLocation.locationName,
                id: this.idCounter ++,
                type: 'BillingLocation',
                value: billingLocation,
            };
            selectedAttributes.push(billingCodeOption);
        }
    }

    private addBillingPeriod(selectedMonth: string) {
        const selectedMonthObj = this.completedMonths.find((m) => m.value === selectedMonth);
        const selectedMonthText = selectedMonthObj ? selectedMonthObj.text : selectedMonth;
        const monthValue = selectedMonthText.split('(')[0].trim();
        if (this.$route.query.invoiceType === 'BillingStatement') {
            const exists = this.selectedBillingStatementAttributes.find((attr: any) => attr.text === monthValue &&
                attr.type === 'BillingPeriod');
            if (!exists) {
                const billingPeriodOption = {
                    text: `${monthValue}`,
                    id: this.idCounter++,
                    type: 'BillingPeriod',
                };
                this.selectedBillingStatementAttributes.push(billingPeriodOption);
            }
        }
    }


    private addStatus(status: any) {
        const exists = this.selectedAttributess.some((attr: any) => attr.text === status);
        if (!exists && status !== 'All') {
            const statusOption = {
                text: status,
                id: this.idCounter ++,
                type: 'Status',
            };
            this.selectedAttributess.push(statusOption);
        }
    }
    private addDatePeriod(datePeriod: any) {
        if (!datePeriod) {
            this.$data.selectedDateRange = '';
            return;
        }
        this.selectedAttributess = this.selectedAttributess.filter(
            (attr: any) => attr.type !== 'Date Period',
        );
        this.selectedAttributess.push({
            text: datePeriod,
            id: this.idCounter++,
            type: 'Date Period',
        });
    }

    private customLabel(option: { text: string }): string {
        const textMappings: Record<string, string> = {
            transportRequest: 'Transportation',
            homeHealthCareRequest: 'Home Health Care',
            deliveryRequest: 'Delivery',
            interpreterRequest: 'Interpretation',
            telemedicineRequest: 'Telemedicine',
            Completed: 'Paid',
            Pending: 'Unpaid',
        };

        return textMappings[option.text] || option.text;
    }

    private async getBillingContacts() {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_ORGANIZATIONS}/${this.organizationId}`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.get<Organization>(apiRequest);
        if (response.success && response.data && response.data.billingContacts) {
            response.data.billingContacts.forEach((contact) => {
                const tmp = {
                    text: contact.name,
                    ...contact,
                };
                this.$data.billingContactOptions.push(tmp);
            });
        }
    }

    private async getMasterInvoiceList(searchString?: string, start?: number) {
        if (start === undefined) {
            start = this.masterInvoiceStart;
        } else {
            this.masterInvoiceStart = start;
        }
        const iHttpService = ObjectFactory.getHttpService();
        const queryRecordsRequest: QueryRecordsRequest = {
            limit: MedTransGoConstants.PAGINATION_LIMIT,
            conditions: [],
            start: start ? start : 0,
            order: {
                createdOn: -1,
            },
        };
        if (this.$data.selectedBillingPeriod) {
            const monthValue = this.$data.selectedBillingPeriod.split('(')[0].trim();
            if (monthValue && queryRecordsRequest.conditions) {
                queryRecordsRequest.conditions.push({
                    op: 'eq',
                    fieldName: 'month',
                    value: monthValue,
                });
            }
        }
        if (this.$data.selectedBillingContacts && this.$data.selectedBillingContacts.length > 0) {
            const billingLocationIds = [...new Set(this.$data.selectedBillingContacts.flatMap
                ((contact: any) => contact.billingLocationIds))] as string[];
            if (billingLocationIds && billingLocationIds.length > 0 && queryRecordsRequest.conditions) {
                queryRecordsRequest.conditions.push({
                    op: 'in',
                    fieldName: 'billingLocationIds',
                    value: billingLocationIds,
                });
            }
        }
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            data: queryRecordsRequest,
            url: `${MedTransGoConstants.HTTP_URL_INVOICE}/masterInvoice/list`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<any>(apiRequest);
        if (response.success && response.data) {
            response.data.forEach((invoice: any) => {
                invoice.amount = MathUtils.formatCurrencyWithoutRound(invoice.amount);
                invoice.dueDate = DateUtils.formatDate(invoice.dueDate, DateUtils.FORMATE_DATE);
            });
        }
        this.msaterDataSource.data = response.data;
        if (response.totalCount) {
            this.msaterDataSource.totalCount = response.totalCount;
        }
    }

    private addCaseNumber(caseNumber: any) {
        const exists = this.selectedAttributess.some((attr: any) => attr.text === caseNumber);
        if (!exists && caseNumber !== 'All') {
            const caseNumberOption = {
                text: caseNumber,
                id: this.idCounter ++,
                type: 'CaseNumber',
            };
            this.selectedAttributess.push(caseNumberOption);
        }
    }

}
